import { Mode } from "..";
import { SingleCooperativeDetails } from "../../../../../redux/features/cooperative/cooperative.type";
import { PermissionCode } from "../../../../../redux/features/settings/settings.type";
import { CooperativeMemberLoansView } from "./member";
import { CooperativeOfficialLoansView } from "./official";

export const CooperativeLoans = ({
  cooperativeDetails,
  mode,
  permissions,
}: {
  cooperativeDetails: SingleCooperativeDetails;
  mode: Mode;
  permissions: PermissionCode[];
}) => {
  return (
    <>
      {mode === "admin" ? (
        <CooperativeOfficialLoansView
          permissions={permissions}
          cooperativeDetails={cooperativeDetails}
        />
      ) : (
        <CooperativeMemberLoansView cooperativeDetails={cooperativeDetails} />
      )}
    </>
  );
};
